import { render, staticRenderFns } from "./TimeDistribution.vue?vue&type=template&id=3642b2b6&"
import script from "./TimeDistribution.vue?vue&type=script&lang=ts&"
export * from "./TimeDistribution.vue?vue&type=script&lang=ts&"
import style0 from "./TimeDistribution.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports